(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('bcmBiaProfileFullController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$timeout', '$state', '$modal', '$q', 'govNotificationDelay', 'biaProfileService', 'biaBuOwnerService', 'notificationService', 'adminReferenceDataService'];

    function Controller($rootScope, $scope, $timeout, $state, $modal, $q, govNotificationDelay, biaProfileService, biaBuOwnerService, notificationService, adminReferenceDataService) {

        $scope.ctrlCtxt = {
            isValidationBoxToDisplay: false
        };

        var nextBIAProfileTaskValue = _.get($scope, 'boxModel.NextItemTaskDefinition.Value');
        $scope.ctrlCtxt.isReadyForPrioritization =
            nextBIAProfileTaskValue === 'NeedAllBiaRespPrioritizedForBIAProfile'
            || nextBIAProfileTaskValue === 'NeedBCCValidation';

        // Init
        init();

        // Is Save Changes Disabled?
        $scope.isSaveChangesDisabled = function (form, boxModel) {
            if (_.isUndefined(form)) return;
            return form.$invalid;
        };

        // Go To BU Owner
        $scope.goToBIABUOwner = function (biabuOwner) {
            $state.go('biaProfile.edit.biaBuOwner', {BIABUOwnerID: biabuOwner.BIABUOwnerID});
        };

        // Delete Initiative
        $scope.deleteBiaProfile = function () {

            if ($scope.ctrlCtxt.isLoading) return;
            $scope.ctrlCtxt.isLoading = true;
            return biaProfileService
                .deleteBIAProfile($scope.boxModel.BIAProfileID)
                .then(function () {
                    $state.go('newBIAProfileSearch');
                });
        };

        // Create BIA Profile
        $scope.createBIAProfile = function () {

            if ($scope.isSaveChangesDisabled($scope.form)) {
                $scope.ctrlCtxt.showSubmitError      = true;
                $scope.ctrlCtxt.isFormInvalidMsgShow = true;

                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                    $scope.ctrlCtxt.showSubmitError      = false;
                }, govNotificationDelay);

                return;
            }

            $scope.ctrlCtxt.showSubmitError      = false;
            $scope.ctrlCtxt.isFormInvalidMsgShow = false;

            return biaProfileService
                .createBIAProfile($scope.boxModel)
                .then(function (createdBiaProfile) {
                    $state.go('biaProfile.edit', {BIAProfileID: createdBiaProfile.BIAProfileID});
                });
        };

        // Reset
        $scope.reset = function () {
            $state.reload();
        };

        // Edit Model Part
        $scope.editModelPart = function (partName) {

            // Modal to show
            var modalScope = $scope.$new(true);

            modalScope.ctrlCtxt              = { };
            modalScope.boxModel              = _.cloneDeep($scope.boxModel);
            modalScope.boxContext            = _.cloneDeep($scope.boxContext);
            modalScope.isSaveChangesDisabled = $scope.isSaveChangesDisabled;

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAProfile/bcmBiaProfile.full_' + partName + '.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            // On BoxModel Save Changes
            modalScope.onBoxModelSaveChanges = function (form) {

                if (modalScope.isSaveChangesDisabled(form, modalScope.boxModel)) {
                    modalScope.ctrlCtxt.showSubmitError      = true;
                    modalScope.ctrlCtxt.isFormInvalidMsgShow = true;

                    $timeout(function () {
                        modalScope.ctrlCtxt.isFormInvalidMsgShow = false;
                        modalScope.ctrlCtxt.showSubmitError      = false;
                    }, govNotificationDelay);

                    return;
                }

                modalScope.ctrlCtxt.showSubmitError      = false;
                modalScope.ctrlCtxt.isFormInvalidMsgShow = false;

                return biaProfileService
                    .updateBIAProfile(modalScope.boxModel.BIAProfileID, modalScope.boxModel)
                    .then(function (updatedBiaProfile) {
                        $scope.boxModel = updatedBiaProfile;
                        modalScope.close();
                        $state.reload();
                    });

            };

            // Close Modal
            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        };

        // Go To BIA Responsibility
        $scope.goToBIAResponsibility = function (biaResp) {
            if (biaResp.PRCResponsibilityID) {

                // Go to BIA Resp for BU Owner
                $state.go('biaProfile.edit.biaBuOwner.biaResponsibility', {
                    BusinessUnitID: biaResp.PRCResponsibility.BusinessUnitID,
                    BIAResponsibilityID: biaResp.BIAResponsibilityID
                });

                return;
            }

            // Go to BIA Resp
            $state.go('biaProfile.edit.biaResponsibility', {
                BIAResponsibilityID: biaResp.BIAResponsibilityID
            });
        };

        // Prioritize BIA Responsibilities
        $scope.prioritizeBIAResps = function () {

            // Modal to show
            var modalScope = $scope.$new(true);

            modalScope.ctrlCtxt = {};
            modalScope.boxModel = _.cloneDeep($scope.boxContext.BIAResponsibilities);
            modalScope.priorityLevels = $scope.boxContext.BCMLookups.PriorityLevels;

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.list.modal.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            $scope.$on('modal.hide', function() {
                $state.reload();
            });

            // Close Modal
            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        };

        // Page is dirty
        $scope.pageIsDirty = function () {
            $rootScope.$broadcast('page-is-dirty');
            $scope.ctrlCtxt.needSaveChanges = true;
        };
        $scope.pageIsNotDirty = function () {
            $rootScope.$broadcast('page-is-not-dirty');
            $scope.ctrlCtxt.needSaveChanges = false;
        };

        // Show Concat list
        $scope.showConcatList = function (data, path) {
            var value = _.join(_.map(data, path), ', ');
            if (value === '') {
                value = 'n/a';
            }
            return value;
        };

        // Go To Add BCM Responsibility
        $scope.goToAddBCMResponsibility = function () {
            $state.go('biaProfile.edit.addBCMResponsibility');
        };

        // Reset BIA Profile Validation
        $scope.resetBIAProfileValidation = function () {
            if ($scope.ctrlCtxt.isLoading) return;

            $scope.ctrlCtxt.isLoading = true;

            biaProfileService
                .resetBIAProfileValidation($scope.boxModel.BIAProfileID)
                .then(function () {
                    notificationService.notify('BC Analysis Successfully Reset');
                    $state.reload();
                })
                .finally(function () {
                    $scope.ctrlCtxt.isLoading = false;
                });
        };

        // Open Validation by Coordinator Modal
        $scope.openValidationByCoordinatorModal = function () {
            if ($scope.ctrlCtxt.isLoading) return;

            var nbBccValidationsLeft = _
                .reduce($scope.boxModel.BusinessContinuityCoordinators, function (count, bcc) {
                    return count + (bcc.HasValidated ? 0 : 1);
                }, 0);

            // Display modal
            var modalScope = $scope.$new(true);

            modalScope.ctrlCtxt = $scope.ctrlCtxt;
            modalScope.ctrlCtxt.isFirstValidation =
                nbBccValidationsLeft === $scope.boxModel.BusinessContinuityCoordinators.length;

            var showModal = $modal({
                scope: modalScope,
                template: '/app/Main/BCM/biaProfileEditValidation.coordinator.modal.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            // When confirming validation
            modalScope.confirmValidation = function () {
                $scope.ctrlCtxt.isLoading = true;

                biaProfileService
                    .validateByCoordinator($scope.boxModel.BIAProfileID)
                    .then(function () {
                        notificationService.notify('BC Analysis Successfully Validated');
                    })
                    .finally(function () {
                        $scope.ctrlCtxt.isLoading = false;
                        modalScope.close();
                        $state.reload();
                    });
            };

            // Close Modal
            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        };

        // --- Activity / Process helpers ---

        var _cachedAPString = null;
        var _cachedAP = [];

        $scope.getActivityProcesses = function () {
            var raw = $scope.boxModel.ActivityProcesses;
            if (!raw) return [];
            if (raw === _cachedAPString) return _cachedAP;
            _cachedAPString = raw;
            var ids;
            try { ids = _.isArray(raw) ? raw : JSON.parse(raw); }
            catch (e) { _cachedAP = []; return _cachedAP; }
            _cachedAP = _.map(ids, function (id) {
                var resolved = _activityProcessMap[id];
                return resolved || { title: '#' + id, domainTitle: null };
            });
            return _cachedAP;
        };

        // Edit Activity / Process
        $scope.editActivityProcesses = function () {
            var modalScope = $scope.$new(true);

            modalScope.ctrlCtxt = {};
            modalScope.boxModel = _.cloneDeep($scope.boxModel);
            modalScope.boxContext = $scope.boxContext;

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/BCM/BIAProfile/bcmBiaProfile.activityProcess.modal.tpl.html',
                placement: 'center',
                backdrop: 'static'
            });

            modalScope.onActivityProcessSave = function (ids) {
                $scope.boxModel.ActivityProcesses = JSON.stringify(ids);
                biaProfileService
                    .updateBIAProfile($scope.boxModel.BIAProfileID, $scope.boxModel)
                    .then(function (updatedBiaProfile) {
                        $scope.boxModel = updatedBiaProfile;
                        modalScope.close();
                        initActivityProcessLookup();
                        notificationService.notify('Activity / Process Saved Successfully');
                    });
            };

            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        };

        // Resolve IDs to display labels
        var _activityProcessMap = {};

        function initActivityProcessLookup() {
            adminReferenceDataService
                .getLookupAttributeValues('BIAResponsibility')
                .then(function (lookupAttributes) {
                    if (!lookupAttributes.BCMActivityProcess) return;

                    var allValues = lookupAttributes.BCMActivityProcess.LookupAttributeValues || [];
                    var level1 = _.keyBy(
                        _.filter(allValues, function (v) { return !v.LookupAttributeValueRelationID; }),
                        'LookupAttributeValueID'
                    );

                    _activityProcessMap = {};
                    _.each(allValues, function (v) {
                        if (v.LookupAttributeValueRelationID) {
                            var domain = level1[v.LookupAttributeValueRelationID];
                            _activityProcessMap[v.LookupAttributeValueID] = {
                                title: v.TitleEN,
                                titleFR: v.TitleFR,
                                domainTitle: domain ? domain.TitleEN : null,
                                domainTitleFR: domain ? domain.TitleFR : null
                            };
                        }
                    });

                    // Force re-resolve cached display
                    _cachedAPString = null;
                });
        }

        initActivityProcessLookup();

        function initForBIAProfileEdit() {

            // Assign BIA Responsibilities to each BIA BU Owner
            var biaRespsByBuID = _.groupBy($scope.boxContext.BIAResponsibilities, function (resp) {
                if (!_.isUndefined(resp.PRCResponsibility)) return resp.PRCResponsibility.BusinessUnitID;
            });
            _.map($scope.boxContext.BIABUOwners, function (biabuOwner) {
                biabuOwner.biaResponsibilities = biaRespsByBuID[biabuOwner.BusinessUnitID];
                return biabuOwner;
            });
        }

        function init() {

            // Init For BIA Profile Edit
            if (_.isUndefined($scope.boxModel)) return;

            initForBIAProfileEdit();

            // Check to display validation box
            $scope.ctrlCtxt.isBCCValidationNeeded =
                _.get($scope, 'boxModel.NextItemTaskDefinition.Value') === 'NeedBCCValidation';
            $scope.ctrlCtxt.isHeadValidationNeeded =
                _.get($scope, 'boxModel.NextItemTaskDefinition.Value') === 'NeedVPValidation';

            $scope.ctrlCtxt.isValidationBoxToDisplay =
                $scope.ctrlCtxt.isBCCValidationNeeded && $scope.boxModel.HasBIAProfile_Coordinator_Validate
                || $scope.ctrlCtxt.isHeadValidationNeeded;

            // Is Current user a BCC
            $scope.currentBCC = _.find(
                $scope.boxModel.BusinessContinuityCoordinators, {
                    ItemPersonID: $scope.authenticatedUser.ItemPersonID
                });

            // Can Reset Validation
            $scope.ctrlCtxt.canResetValidation = $scope.boxModel.HasBIAProfile_Reset && $scope.boxModel.IsReadOnly;
        }
    }
})();